<template>
	<div class="input-date-picker">
		<button @click.stop="onClickPrev"><shape src="/static/svg/buttons/back.svg" class="left"/></button>
		<input-date v-model="selectedDate" name="selectedDate" @input="onInput"/>
		<button @click.stop="onClickNext"><shape src="/static/svg/buttons/back.svg" class="right"/></button>
	</div>
</template>

<script>
export default {
	props: [
		'value'
	],
	data () {
		return {
			selectedDate: this.$moment().format('YYYY-MM-DD')
		}
	},
	watch: {
		value (value) {
			this.selectedDate = value
		}
	},
	methods: {
		onClickPrev () {
			this.selectedDate = this.$moment(this.selectedDate).subtract(1, 'd').format('YYYY-MM-DD')
		},
		onClickNext () {
			this.selectedDate = this.$moment(this.selectedDate).add(1, 'd').format('YYYY-MM-DD')
		},
		onInput () {
			this.$emit('input', this.selectedDate)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/InputDatePicker.vue